import Admin from "../../../models/Admin";

export interface authStateInterface {
  userAuth: any;
  user: Admin | null;
  userLoading: boolean;
}

const initState = {
  userAuth: null,
  user: null,
  userLoading: true,
};

const authReducer: any = (state = initState, action: any) => {
  switch (action.type) {
    case "UPDATE_USER_AUTH":
      return {
        ...state,
        userAuth: action.payload.userAuth,
        userLoading: false,
      };
    case "UPDATE_USER":
      return {
        ...state,
        user: action.payload.user,
      };
    default:
      return state;
  }
};

export default authReducer;
